import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierListModal from "../components/supplierListModal";
import ItemListModalPr from "../components/itemListModalPr";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const AddPr = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [priorNo, setPriorNo] = useState('');
  const [formData, setFormData] = useState({ indentNo: "", remarks: "", department: "" });
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
  const fetchPriorNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_no`);
      if (response.data.priorPrNo) {
        console.log(response.data.priorPrNo);
        
        const newPrNo = parseInt(response.data.priorPrNo, 10) || 0;
        setPriorNo(newPrNo.toString());
        setFormData(prevState => ({ ...prevState, newPriorNo: newPrNo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPriorNo();
}, []);

useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/prPurchase_branches`);
        setBranches(response.data.branches || []);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };
    fetchBranches();
  }, []);


  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [
      ...prevItems,
      { ...item, vcode: "", vnumber: "", qty: "", duedate: "" },
    ]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleVehicleSelect = (supplierMaster_code, supplierMaster_name) => {
    if (!supplierMaster_code || !supplierMaster_name) {
      console.error("Supplier selection error: Missing supplier code or name");
      return;
    }
  
    console.log("Selected Supplier:", supplierMaster_code, supplierMaster_name);
  
    // Update formData with the selected supplier
    setFormData((prevData) => ({
      ...prevData,
      supplierCode: supplierMaster_code,
      supplierName: supplierMaster_name,
    }));
  
    setShowVehicleModal(false);
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Function to submit the form data
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.newPriorNo || !formData.newPriorNo.trim()) {
    Swal.fire("Warning", "Indent No is required!", "warning");
    return;
  }

  if (!formData.supplierCode) {
    Swal.fire("Warning", "Supplier must be selected!", "warning");
    return;
  }

  if (!formData.department) {
    Swal.fire("Warning", "Please select a Branch!", "warning");
    return;
  }

  if (!formData.hod || !formData.hod.trim()) {
    Swal.fire("Warning", "H.O.D is required!", "warning");
    return;
  }

  if (!formData.indenter || !formData.indenter.trim()) {
    Swal.fire("Warning", "Indenter is required!", "warning");
    return;
  }

  if (!formData.hm || !formData.hm.trim()) {
    Swal.fire("Warning", "Head Material is required!", "warning");
    return;
  }


  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

   for (let i = 0; i < selectedItems.length; i++) {
  const item = selectedItems[i];

  // ✅ Check empty due date
  if (!item.duedate || item.duedate.toString().trim() === "") {
    Swal.fire(
      "Warning",
      `Due Date is required for item ${i + 1} (${item.itemmaster_name})`,
      "warning"
    );
    return;
  }

  // ✅ Parse dates safely (ignores time part)
  const today = new Date();
  today.setHours(0, 0, 0, 0); // reset time
  const dueDate = new Date(item.duedate);
  dueDate.setHours(0, 0, 0, 0);

  // ✅ Check for past date
  if (dueDate < today) {
    Swal.fire(
      "Warning",
      `Due Date for item ${i + 1} (${item.itemmaster_name}) must be today or a future date.`,
      "warning"
    );
    return;
  }
}




  // ✅ continue with payload
  const payload = {
    branch: branch,
    user: userId,
    priorNo: formData.newPriorNo,
    supplierCode: formData.supplierCode,
    hod: formData.hod,
    indentNo: fld_purnumber,
    hm: formData.hm,
    remarks: formData.remarks,
    items: selectedItems.map((item) => ({
      itemCode: item.itemmaster_code,
      itemName: item.itemmaster_name,
      itemUom: item.itemmaster_uom,
      qty: item.fld_qty,
      duedate: item.duedate,
      price: item.supplierWIdetail_price,
    })),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/prPurchase_insert",
      payload
    );

    Swal.fire("Success", "Prior Purchase added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/prview");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Add Prior Purchase
          </h2>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Indent No :</label>
                <input type="text" name="indentNo" value={formData.newPriorNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs"value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="supplier" value={formData.supplierCode || ""} readOnly onClick={() => setShowVehicleModal(true)} placeholder="Select Supplier"/>
              </div>

              <div className="form-group">
                <label>Supplier Name:</label>
                <input type="text" name="supplierName" value={formData.supplierName || ""} readOnly />
              </div>
            </div>



            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" name="remarks" value={fld_purnumber} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Branch :</label>
                <select name="department" value={formData.department} onChange={handleChange}>
                  <option value="">-- Select Branch --</option>
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" name="hod" value={formData.hod} onChange={handleChange}/>
              </div>

              <div className="form-group">
                <label>Indenter :</label>
                <input type="text" name="indenter" value={formData.indenter} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label>Head Meterial :</label>
                <input type="text" name="hm" value={formData.hm} onChange={handleChange}/>
              </div>
            </div>

           <div className="flex_buttons">
  <button
    type="button"
    className="button button-add"
    onClick={() => {
      if (!formData.supplierCode) {
        Swal.fire("Warning", "Please select supplier first!", "warning");
        return;
      }
      setShowModal(true);
    }}
  >
    Add Item
  </button>
</div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>PF%</th>
                    <th>Disc%</th>
                    <th>Due Date</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td>{item.fld_qty}</td>
                        <td>{item.supplierWIdetail_price}</td>
                        <td>{item.SupplierWIDetail_CSTtax}</td>
                        <td>{item.supplierWIdetail_PfPercentage}</td>
                        <td>{item.supplierWIdetail_discountPercentage}</td>
                        <td>
                          <input
                            type="date"
                            value={item.duedate}
                            onChange={(e) => handleRowChange(index, "duedate", e.target.value)}
                          />
                        </td>
                        <td className="del">
                          <i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>
      <ItemListModalPr showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} supplierCode={formData.supplierCode} fld_purnumber={fld_purnumber} />
      <SupplierListModal showModal={showVehicleModal} closeModal={() => setShowVehicleModal(false)} onSelectVehicle={handleVehicleSelect} branch={branch} fld_purnumber={fld_purnumber}
      />
    </div>
  );
};

export default AddPr;
